function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { StreamQuality } from '../../../core/player/playout-data';
var streamQualityDefaultPropertyName = 'streamQualityDefault';
export function getStreamQualityConfig(devicePlaybackTypeConfig, defaultConfig, playoutData) {
    var _playoutData_stream;
    var quality = playoutData === null || playoutData === void 0 ? void 0 : (_playoutData_stream = playoutData.stream) === null || _playoutData_stream === void 0 ? void 0 : _playoutData_stream.quality;
    var overriddenDefaultConfig = defaultConfig;
    return _object_spread({}, !isStreamQualityDefined(defaultConfig) ? defaultConfig : {}, overriddenDefaultConfig === null || overriddenDefaultConfig === void 0 ? void 0 : overriddenDefaultConfig.streamQualityDefault, devicePlaybackTypeConfig === null || devicePlaybackTypeConfig === void 0 ? void 0 : devicePlaybackTypeConfig.streamQualityDefault, !isStreamQualityDefined(devicePlaybackTypeConfig) ? devicePlaybackTypeConfig : {}, overriddenDefaultConfig === null || overriddenDefaultConfig === void 0 ? void 0 : overriddenDefaultConfig[quality], devicePlaybackTypeConfig === null || devicePlaybackTypeConfig === void 0 ? void 0 : devicePlaybackTypeConfig[quality]);
}
function isStreamQualityDefined(config) {
    var isPresent = false;
    Object.keys(config).forEach(function(key) {
        if (key in StreamQuality || key === streamQualityDefaultPropertyName) {
            isPresent = true;
        }
    });
    return isPresent;
}

//# sourceMappingURL=stream-quality-config.js.map